import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import Banner from "../image/theme/banner-medical.png"
import Ben1 from "../image/theme/icon1.png"
import Ben2 from "../image/theme/icon2.png"
import Ben3 from "../image/theme/time-saving.png"
import KeyFeatures from './key-features';
export default class Medical extends Component {


  render() {
    return (
      <div className="ph-main-wrapper">
        <Header></Header>
        <div className='row d-flex align-items-center m-0'>
          <div className="col-12 col-lg-6 pl-md-5">
            <div className='text-center px-4'>
              <h1 class="ph-main-title-2 mt-4">Clinic Management Software</h1>
              <p className="lead text-left">
                Our clinic management software is the ultimate solution for streamlining your practice and improving patient care. With our all-in-one solution, take your practice to the next level!

              </p>
            </div>
          </div>
          <div className="col-12 col-lg-6 p-0">
            <img src={Banner} alt="Banner" width="100%" height="600" className='img-fluid' />
          </div>
        </div>
        <div className='benefits-section pt-5 pb-2 py-lg-5 py-md-5'>
          <div className="container">
            <h2 class="ph-main-title-2 text-center pb-lg-2 pb-0">Benefits</h2>
            <div className="row m-0 px-lg-1 px-md-1 pb-5 px-0">
              <div className="col-lg-4 mb-lg-0 mb-5">
                <div className='benefits-img'>
                  <img src={Ben2} alt="Ben1" width="40" height="40" className='img-fluid' />
                </div>
                <div className="benefits-head">Easy to use</div>
                <div>Our clinic management software is designed with the user in mind. It's easy to navigate and use, even for those who are not tech-savvy.
                </div>
              </div>
              <div className="col-lg-4 mb-lg-0 mb-5">
                <div className='benefits-img'>
                  <img src={Ben1} alt="Ben1" width="30" height="30" className='img-fluid' />
                </div>
                <div className="benefits-head">All-in-one solution</div>
                <div>Our clinic management software includes everything you need to manage your practice, from appointment scheduling to patient billing.</div>
              </div>
              <div className="col-lg-4 mb-lg-0 mb-5">
                <div className='benefits-img'>
                  <img src={Ben3} alt="Ben1" width="30" height="30" className='img-fluid' />
                </div>
                <div className="benefits-head">Time-saving</div>
                <div>Our clinic management software can help you save time by automating many of the tasks that you currently do manually.</div>
              </div>
            </div>
          </div>
        </div>
        <KeyFeatures />
        <div className='plan-section py-5'>
          <div className="container mb-lg-5 mb-0">
            <h2 class="ph-main-title-2 text-center">Choose One of our Amazing Plans!</h2>
            <div className='row'>
              <div className='col-md-4 mb-4 mb-md-0'>
                <div className='col-md-12 card plan-list'>
                  <div class="card-body px-0 d-flex flex-column">
                    <h2 className='plan-list-head'>Practice Management App</h2>
                    <div className='plan-list-rate pl-3'>
                      <span class="badge badge-primary mt-2">Free</span>
                    </div>
                    <ul className='plan-list-ul'>
                      <li>For single practitioners</li>
                      <li>Includes prescriptions, billing, patient records</li>
                      <li>iOS & Android</li>
                      <li>Integrated Telehealth - Video & Chat consults</li>
                      <li>Secure & Private data with 256 Bit SSL Encrytion</li>
                    </ul>
                  </div>

                </div>
              </div>
              <div className='col-md-4 mb-4 mb-md-0'>
                <div className='col-md-12 card plan-list'>
                  <div class="card-body px-0 d-flex flex-column">
                    <h2 className='plan-list-head'>Practice Management System

                      <div className='plan-list-head-small'> (Mobile App + Desktop)</div>
                    </h2>

                    <div className='plan-list-rate pl-3'>
                      <span class="badge badge-primary mt-2">Rs. 11,999*</span>
                    </div>
                    <ul className='plan-list-ul'>
                      <li>Full featured CMS including prescriptions, billing, electronic patient health records and all key features</li>
                      <li>Multiple dentists and clinics</li>
                      <li>Staff access and administration</li>
                      <li>Reporting and Analytics</li>
                      <li>Fully private patient data and secure file storage with 256 Bit SSL Encryption</li>

                    </ul>
                    <div className='medical_special'>*Special price available. Contact us today!</div>
                  </div>
                </div>
              </div>
              <div className='col-md-4 mb-4 mb-md-0'>
                <div className='col-md-12 card plan-list'>
                  <div class="card-body px-0 d-flex flex-column">
                    <h2 className='plan-list-head'>Branded Website </h2>
                    <div className='plan-list-rate pl-3'>
                      <span class="badge badge-primary mt-2">Rs. 11,999*</span>
                    </div>
                    <ul className='plan-list-ul'>
                      <li> Your own branding, colours & logo</li>
                      <li>Integrated Patient Booking</li>
                      <li>SEO Friendly to improve search engine rank</li>
                      <li>Content system to add blogs, images and videos</li>
                    </ul>
                    <div className='medical_special'>*Special price available. Contact us today!</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    )
  }
}
